import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefHistoryOBGyHistoryMenstrualDurationDetailByID = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryMenstrualDuration/GetDetail?` + params, null);

export const GetRefHistoryOBGyHistoryMenstrualDurationList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryMenstrualDuration/GetList?` + params, null);

export const CreateRefHistoryOBGyHistoryMenstrualDuration = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryMenstrualDuration/Create`, data);

export const UpdateRefHistoryOBGyHistoryMenstrualDuration = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryMenstrualDuration/Update`, data);

export const DeleteRefHistoryOBGyHistoryMenstrualDuration = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryMenstrualDuration/Delete`, data);